import { GroupMessengerDiscussion } from '../../types';
import { ApiWrapper } from '../../types/utils';
import { OF } from '../../util';
import { JBaseApi } from '../base';

export class JMessengerApi extends JBaseApi {
    /**
     * Warning - Old type format
     * @TODO - Implement new format
     */
    public sendMessage(message: string, idDiscussion: string): Promise<ApiWrapper<Record<string, never>>> {
        return this.network.post({
            o: 'messenger',
            f: 'newMessage',
            idDiscussion,
            msg: { description: message },
        } as OF);
    }

    /**
     * Warning - Old type format
     * @TODO - Implement new format
     */
    public getOrCreateDiscussion(idSender: number, idUserTo: number): Promise<ApiWrapper<Record<string, never>>> {
        const idDiscussion = idSender < idUserTo ? `${idSender}.${idUserTo}` : `${idUserTo}.${idSender}`;
        return this.network.post({
            o: 'messenger',
            f: 'getDiscussion',
            idDiscussion,
            type: 'messengerUser',
            idUserTo,
        } as OF);
    }

    public enableDiscussion(payload: { uri: string }, signal?: AbortSignal) {
        return this.network.postCSRF<boolean>(
            {
                o: 'messenger',
                f: 'discussionEnable',
                ...payload,
            } as OF,
            signal,
        );
    }

    public disableDiscussion(payload: { uri: string }, signal?: AbortSignal) {
        return this.network.postCSRF<boolean>(
            {
                o: 'messenger',
                f: 'discussionDisable',
                ...payload,
            } as OF,
            signal,
        );
    }

    public getSpotDiscussion(
        payload: { uri: string },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<GroupMessengerDiscussion>> {
        return this.network.post(
            {
                o: 'messenger',
                f: 'getSpotDiscussion',
                ...payload,
            } as OF,
            signal,
        );
    }

    public createSpotDiscussion(
        payload: { uri: string },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<GroupMessengerDiscussion>> {
        return this.network.postCSRF(
            {
                o: 'messenger',
                f: 'createSpotDiscussion',
                ...payload,
            } as OF,
            signal,
        );
    }
}
